import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import useFromEvent from '@swf/core/hooks/useFromEvent';
import { select } from '@swf/core/store';

export const useNativeLoader = (): void => {
  const hasClientSession = useSelector(select.session.hasClientSession);
  const fromEvent = useFromEvent();

  useEffect(() => {
    if (!hasClientSession) return;

    window.starsweb?.app.ready
      ? window.starsweb?.app.setLoading?.(false)
      : fromEvent(document, 'starsready').subscribe(() => window.starsweb?.app.setLoading?.(false));
  }, [hasClientSession, fromEvent]);
};
